import { useContext } from "react";
import { CartContext } from '../../contexts/CartContext';
import { CurrencyContext } from '../../contexts/CurrencyContext';
import { hostingPaymentErrorMessage } from "../../api/global";
import { DISPLAY_LANG } from "../../config";
import { useNavigate } from "react-router-dom";

export default function CartTotal({ pagedata }) {
    const { goToPaymentMethodPage, cartTotalAmount, cursorLoad, setCursorLoad } = useContext(CartContext);
    const { selectedCurrency } = useContext(CurrencyContext);
    const navigate = useNavigate();

    const handlePayClick = async () => {
        setCursorLoad(true);
        try {
            const path = await goToPaymentMethodPage();
            navigate(path);
        } catch (error) {
            console.log(error);
            alert(hostingPaymentErrorMessage[DISPLAY_LANG]);
        } finally {
            setCursorLoad(false);
        }
    };

    return (
        <div className="total">
            <div className='flex-between'>
                <p>{pagedata.total_label}</p>

                <div className='flex-center price-box'>
                    {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                    <p>{cartTotalAmount}</p>
                    {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}
                </div>
            </div>

            <button
                className='btn pay-btn flex-center'
                onClick={() => !cursorLoad && handlePayClick()}
                style={{ cursor: cursorLoad ? 'wait' : '' }}
            >
                {pagedata.btn_text}
            </button>
        </div>
    )
}
